import React from 'react';

import { LANGUAGES } from '../../constants/languages';
import { StoreContext } from '../../store/store';
import { Text } from '../text/text';
import { Translate } from '../translate';
import './checkbox.scss';

interface CheckboxProps {
  handleChange: (e) => void;
  checked: boolean;
}
const getEnTosLink = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('co.uk')) {
    return 'https://www.siteground.co.uk/viewtos/privacy_policy?scid=2&lang=en_GB';
  }
  if (hostname.includes('eu')) {
    return 'https://eu.siteground.com/viewtos/privacy_policy?scid=3&lang=en';
  }
  if (hostname.includes('world')) {
    return 'https://world.siteground.com/viewtos/privacy_policy?scid=2&lang=en';
  }
  if (hostname.includes('au')) {
    return 'https://au.siteground.com/viewtos/privacy_policy?scid=2&lang=en';
  }
  return 'https://www.siteground.com/viewtos/privacy_policy?scid=4&lang=en';
};

const getEsTosLink = () => {
  const hostname = window.location.hostname;

  if (hostname.includes('es.siteground.com')) {
    return 'https://es.siteground.com/viewtos/privacy_policy?scid=3&lang=es_ES';
  }

  if (hostname.includes('siteground.es')) {
    return 'https://siteground.es/viewtos/privacy_policy?scid=3&lang=es_ES';
  }

  return 'https://www.siteground.com/es/viewtos/privacy_policy?scid=4&lang=es_ES';
};

const tosLinks = {
  [LANGUAGES.EN]: getEnTosLink(),
  [LANGUAGES.ES]: getEsTosLink(),
  [LANGUAGES.IT]: 'https://it.siteground.com/viewtos/privacy_policy?scid=3&lang=it_IT',
  [LANGUAGES.DE]: 'https://de.siteground.com/viewtos/privacy_policy?scid=3&lang=de_DE',
  [LANGUAGES.FR]: 'https://fr.siteground.com/viewtos/privacy_policy?scid=3&lang=fr_FR'
};

const Checkbox: React.FC<CheckboxProps> = ({ checked, handleChange }) => {
  const { state } = React.useContext(StoreContext);
  const lang = state.config.language;
  return (
    <div data-component="checkbox">
      <label className="rc-checkbox">
        <input
          className="rc-checkbox__input"
          name="checked"
          type="checkbox"
          checked={checked}
          onChange={handleChange}
        />
        <span className={`rc-checkbox__box ${checked ? 'checked' : ''}`} />
        <Text size="small">
          <Translate id="translate.rc.tos" values={{ link: tosLinks[lang] }} />
        </Text>
      </label>
    </div>
  );
};

export default Checkbox;
